
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
import store from '@/store/store';
import {Modal} from 'view-design';
import {commonLocalStorage} from '@/utils/common';

// 状态获取
const getState = (key, defaultValue = null) => {
  return store.state?.[key] ?? commonLocalStorage.getItem(key) ?? defaultValue;
};

// 路由映射 - 使用动态导入避免循环依赖
const routerModules = {
  yms: null,
  supplier: null,
  distributor: null
};

// 获取 router 实例（懒加载）
const getRouter = async (system) => {
  if (!routerModules[system]) {
    const module = await import(`@/views/${system}/router/index.js`);
    routerModules[system] = module.default;
  }
  return routerModules[system];
};

// 路由功能开关配置
const guardMap = {
  // 运营系统
  yms: [
    {
      paths: ['/orderCollectionAccount', '/orderPaymentReconciliation'],
      check: () => Number(getState('configurationItemInfo')?.offlinePayment) !== 0,
      msg: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001636')
    },
    {
      paths: [
        '/selfOperatedProductsList',
        '/selfOperatedProductsViewSku',
        '/selfOperatedProductsDetails'
      ],
      check: () => Number(getState('saasConfigurationItems')?.platformSelfOperatedProductModelSaas) !== 0,
      msg: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001637')
    }
  ],
  // 供应商系统
  supplier: [
    {
      paths: ['/platformAuthorization'],
      check: () =>
        Array.isArray(getState('configurationItemInfo')?.suppliePlatformSet) &&
        getState('configurationItemInfo')?.suppliePlatformSet?.length > 0,
      msg: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001638')
    }
  ],
  // 分销商系统
  distributor: [
    {
      paths: ['/paymentManagement'],
      check: () => Number(getState('configurationItemInfo')?.offlinePayment) !== 0,
      msg: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001639')
    },
    {
      paths: ['/complianceResponsiblePersonList', '/manufacturerInfoList'],
      check: () => Number(getState('saasConfigurationItems')?.orderComplianceLabelVerificationSaas) !== 0,
      msg: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001640')
    }
  ]
};

// 菜单扁平化（极简版）
const flatMenu = (list = []) =>
  list.reduce((acc, i) => {
    acc.push(i);
    i.children?.length && acc.push(...flatMenu(i.children));
    return acc;
  }, []);

// 获取第一个可访问页面
const getFirstPage = () => {
  const menu = getState('pagesPermissions', []);
  const role = getState('roleData', []);
  if (!menu.length || !role.length) return '/';
  return (
    flatMenu(menu).find((i) => {
      if (!i.path) return false;
      if (i.jurisdictionHide) return true;
      return i.menuKey && role.includes(i.menuKey);
    })?.path || '/'
  );
};

// 显示提示弹窗
const showModal = ({msg, system}) => {
  Modal.warning({
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
    content: msg || aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001641'),
    okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316'),
    closable: false,
    maskClosable: false,
    onOk: async () => {
      const router = await getRouter(system);
      const target = getFirstPage();
      if (!router || !target) return;
      if (router.currentRoute?.path !== target) {
        router.replace(target);
      }
    }
  });
};

// 路由功能开关验证
export const validateConfigRouteAccess = (to, system = 'yms') => {
  try {
    const rule = guardMap[system]?.find((r) => r.paths.includes(to.path));
    if (!rule || rule.check()) return true;
    showModal({msg: rule.msg, system});
    return false;
  } catch (e) {
    console.error('route guard error:', e);
    return true;
  }
};

export default validateConfigRouteAccess;